import { render, staticRenderFns } from "./RemoveSupporter.vue?vue&type=template&id=030f4ef3&scoped=true&"
import script from "./RemoveSupporter.vue?vue&type=script&lang=js&"
export * from "./RemoveSupporter.vue?vue&type=script&lang=js&"
import style0 from "./RemoveSupporter.vue?vue&type=style&index=0&id=030f4ef3&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030f4ef3",
  null
  
)

export default component.exports